import React, { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { appUrl } from '../..';

function RedCactusEncodedRecordingUrl() {
    const { encodedCallDetails } = useParams(); 
    const navigate = useNavigate();

    useEffect(()=>{
        if(!encodedCallDetails){
            navigate("/home");
            return;
        }

        let decodedCallDetails = "";

        try{
            decodedCallDetails = atob(encodedCallDetails ?? "");
        }catch(e){
            navigate("/home");
            return;
        }

        const [platformCallDetailId, recordingId] = decodedCallDetails.split("##");

        if(!platformCallDetailId || !recordingId){
            navigate("/home");
            return;
        }   

        const navigateURL = `${appUrl}/calldetail/${platformCallDetailId}?recordingId=${recordingId}`;
        window.location.replace(navigateURL);

    },[encodedCallDetails])

    return null;
}

export default RedCactusEncodedRecordingUrl